<template>
  <div class="payment-summary">
    <div class="text-highlight mr-3">
      <div>Cost:</div>
      <div>Paid:</div>
      <div v-if="registration.balance_due > 0">Balance Due:</div>
    </div>
    <div>
      <div>
        {{registration.calc_amount_total | currency}}<span class="invisible">*</span>
      </div>
      <div>
        {{registration.total_collected | currency}}<span class="invisible">*</span>
      </div>
      <div v-if="registration.balance_due > 0">
        {{registration.balance_due | currency}}<span>*</span>
      </div>
    </div>
  </div>
</template>

<script>
import AppMixin from '../services/mixin.app';

export default {
  name: 'payment-summary',
  props: ['registration'],
  mixins: [AppMixin],
};
</script>
